<template>
  <div class="login-container">
    <form class="form" @submit.prevent="handleLogin">
      <!-- 欢迎标题 -->
      <div class="welcome-header">
        <h1 class="welcome-title">用户登录</h1>
        <p class="welcome-subtitle">欢迎回来，请登录您的账户</p>
      </div>

      <div class="flex-column">
        <label>用户名/邮箱</label>
      </div>
      <div class="inputForm">
        <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
          <g id="Layer_3" data-name="Layer 3">
            <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
          </g>
        </svg>
        <input
          type="text"
          class="input"
          placeholder="请输入用户名或邮箱"
          v-model="formData.userToken"
        >
      </div>

      <div class="flex-column">
        <label>密码</label>
      </div>
      <div class="inputForm">
        <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
          <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
          <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
        </svg>
        <input
          :type="showPassword ? 'text' : 'password'"
          class="input"
          placeholder="请输入密码"
          v-model="formData.password"
        >
        <!-- 睁眼图标 - 密码隐藏时显示 -->
        <svg 
          v-if="!showPassword"
          class="eye-icon" 
          @click="togglePasswordVisibility"
          viewBox="0 0 576 512" 
          height="1em" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
        </svg>
        <!-- 闭眼图标 - 密码显示时显示 -->
        <svg 
          v-else
          class="eye-icon" 
          @click="togglePasswordVisibility"
          viewBox="0 0 640 512" 
          height="1em" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
        </svg>
      </div>

      <div class="flex-row">
        <div class="remember-me">
          &nbsp;
          <input type="checkbox" v-model="rememberMe" id="rememberMe">
          <label for="rememberMe">&nbsp;记住我</label>
        </div>
        <span class="span" @click="goToResetPassword">忘记密码？</span>
      </div>

      <button class="button-submit" type="submit" :disabled="loading">
        {{ loading ? '登录中...' : '登录' }}
      </button>

      <p class="p">还没有账号？<span class="span" @click="goToRegister">立即注册</span></p>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '../api/auth'
import toast from '../utils/toast'

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter()
    
    // 从 localStorage 读取保存的账号信息
    const savedUsername = localStorage.getItem('savedUsername') || ''
    const savedPassword = localStorage.getItem('savedPassword') || ''
    const hasSavedCredentials = !!(savedUsername && savedPassword)
    
    // 从路由参数中获取用户名和密码（注册成功后自动填充）
    const route = router.currentRoute.value
    const autoFillUsername = route.query.username || savedUsername
    const autoFillPassword = route.query.password || savedPassword
    const shouldAutoFill = route.query.autoFill === 'true' || hasSavedCredentials
    
    const formData = ref({
      userToken: autoFillUsername,
      password: autoFillPassword,
      token: ''
    })

    const rememberMe = ref(shouldAutoFill) // 如果是自动填充或有保存的凭据，默认勾选记住我
    const loading = ref(false)
    const showPassword = ref(false)

    const handleLogin = async () => {
      // 验证表单
      if (!formData.value.userToken) {
        toast.error('请输入用户名或邮箱')
        return
      }

      if (!formData.value.password) {
        toast.error('请输入密码')
        return
      }

      loading.value = true

      try {
        const response = await login({
          userToken: formData.value.userToken,
          password: formData.value.password,
          token: formData.value.token
        })

        if (response.code === 1) {
          // 登录成功
          // toast.success(response.msg || '登录成功')
          console.log('登录成功，Cookie 已保存')

          // 处理"记住我"功能
          if (rememberMe.value) {
            // 勾选了"记住我"，保存用户名和密码到 localStorage
            localStorage.setItem('savedUsername', formData.value.userToken)
            localStorage.setItem('savedPassword', formData.value.password)
            console.log('✅ 已保存登录信息')
          } else {
            // 未勾选"记住我"，清除 localStorage 中的保存信息
            localStorage.removeItem('savedUsername')
            localStorage.removeItem('savedPassword')
            console.log('🗑️ 已清除保存的登录信息')
          }

          // 检查cookie是否正确设置
          const checkCookie = () => {
            const cookies = document.cookie.split(';')
            for (let cookie of cookies) {
              const [name, value] = cookie.trim().split('=')
              if (name === 'share-session' && value && value.trim() !== '') {
                console.log('✅ Cookie验证成功:', value.substring(0, 10) + '...')
                return true
              }
            }
            console.log('❌ Cookie验证失败')
            return false
          }

          // 延迟一点检查cookie
          setTimeout(() => {
            if (checkCookie()) {
              console.log('🎯 跳转到车辆列表页面')
              router.push('/carlist')
            } else {
              console.log('⚠️ Cookie未正确设置，重试...')
              setTimeout(checkCookie, 1000)
            }
          }, 100)
        } else if (response.code === 0 || response.code === -1) {
          // 登录失败
          toast.error(response.msg || '登录失败')
        } else {
          toast.error('未知错误')
        }
      } catch (error) {
        console.error('登录错误:', error)
        if (error.response) {
          // 服务器返回了错误响应
          const data = error.response.data
          if (data && data.msg) {
            toast.error(data.msg)
          } else if (error.response.status === 404) {
            toast.error('接口不存在，请检查配置')
          } else if (error.response.status === 500) {
            toast.error('服务器错误，请稍后重试')
          } else {
            toast.error('登录失败，请稍后重试')
          }
        } else if (error.request) {
          // 请求已发送但没有收到响应
          toast.error('网络超时，登陆失败，请重试')
        } else {
          // 请求配置出错
          toast.error('请求失败，请稍后重试')
        }
      } finally {
        loading.value = false
      }
    }

    const goToRegister = () => {
      router.push('/register')
    }

    const goToResetPassword = () => {
      router.push('/resetpwd')
    }

    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value
    }

    return {
      formData,
      rememberMe,
      loading,
      showPassword,
      handleLogin,
      goToRegister,
      goToResetPassword,
      togglePasswordVisibility
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #ffffff;
}

.welcome-header {
  text-align: center;
  margin-bottom: 30px;
}

.welcome-title {
  font-size: 28px;
  font-weight: 700;
  color: #151717;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.welcome-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  font-weight: 400;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #ffffff;
  padding: 30px;
  width: 450px;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

::placeholder {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.form button {
  align-self: flex-end;
}

.flex-column > label {
  color: #151717;
  font-weight: 600;
}

.inputForm {
  border: 1.5px solid #ecedec;
  border-radius: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  transition: 0.2s ease-in-out;
}

.input {
  margin-left: 10px;
  border-radius: 10px;
  border: none;
  width: 85%;
  height: 100%;
}

.input:focus {
  outline: none;
}

/* 去除浏览器自动填充的蓝色阴影/背景 */
.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #151717 !important;
  box-shadow: 0 0 0 30px white inset !important;
  transition: background-color 5000s ease-in-out 0s;
}

/* 针对密码输入框的自动填充样式 */
.input[type="password"]:-webkit-autofill,
.input[type="password"]:-webkit-autofill:hover,
.input[type="password"]:-webkit-autofill:focus,
.input[type="password"]:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #151717 !important;
}

.inputForm:focus-within {
  border: 1.5px solid #2d79f3;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.flex-row > div > label {
  font-size: 14px;
  color: black;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 4px;
}

.remember-me input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.span {
  font-size: 14px;
  margin-left: 5px;
  color: #2d79f3;
  font-weight: 500;
  cursor: pointer;
}

.eye-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
  margin-right: 8px;
  color: #666;
}

.eye-icon:hover {
  opacity: 0.7;
  color: #2d79f3;
}

.button-submit {
  margin: 20px 0 10px 0;
  background-color: #151717;
  border: none;
  color: white;
  font-size: 15px;
  font-weight: 500;
  border-radius: 10px;
  height: 50px;
  width: 100%;
  cursor: pointer;
  transition: 0.3s ease;
}

.button-submit:hover {
  background-color: #252727;
}

.button-submit:disabled {
  background-color: #666;
  cursor: not-allowed;
}

.p {
  text-align: center;
  color: black;
  font-size: 14px;
  margin: 5px 0;
}

.btn {
  margin-top: 10px;
  width: 100%;
  height: 50px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  gap: 10px;
  border: 1px solid #ededef;
  background-color: white;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.btn:hover {
  border: 1px solid #2d79f3;
}

.line {
  position: relative;
  color: #999;
}

.line::before,
.line::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 40%;
  height: 1px;
  background-color: #ddd;
}

.line::before {
  left: 0;
}

.line::after {
  right: 0;
}
</style>

